import { compose } from 'recompose'
import { connect } from 'react-redux'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import ServiceItem from './ServiceItem'

export default compose(
  connect(null, { showStoreLocatorModalInAppointmentMode })
)(ServiceItem)
